<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'销售经理导入详情'}]"/>-->
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询表单-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="经销商名称/编码" prop="agentNameLike">
              <el-input v-model="q.agentNameLike" placeholder="请输入编码或名称"></el-input>
            </el-form-item>
            <el-form-item label="经销商类型" prop="agentNameLike">
              <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
            </el-form-item>
            <el-form-item label="签约链群" prop="rebateChainGroup">
              <brselect category="fl_25_chain_group" :v="q.rebateChainGroup" v-model="q.rebateChainGroup" :multiple="true"
                        :clearable="true"/>
            </el-form-item>
            <el-form-item label="渠道" prop="salesRegionCode">
              <brselect category="fl_sales_region_main" :v="q.salesRegionCode" v-model="q.salesRegionCode" :multiple="true"
                        :clearable="true"/>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="年份" prop="year">
                  <el-select filterable v-model="q.year" clearable placeholder="请选择">
                    <el-option value="2020">
                    </el-option>
                    <el-option value="2021">
                    </el-option>
                    <el-option value="2022">
                    </el-option>
                    <el-option value="2023">
                    </el-option>
                    <el-option value="2024">
                    </el-option>
                    <el-option value="2025">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="区域" prop="areaCode">
                  <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true"
                            :clearable="true"/>
                </el-form-item>
                <el-form-item label="返利归属产业" prop="belongIndustry">
                  <brselect category="fl_belong_industry" :v="q.belongIndustry" v-model="q.belongIndustry" :multiple="true"
                            :clearable="true"/>
                </el-form-item>
              </div>
            </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
          </div>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30 sjwstyle">
        <el-table
            ref="ddtable"
            :data="tableData"
            stripe
            style="width: 100%"
            :border="true"
            max-height="520"
        >
          <el-table-column
              type="index"
              label="#"
              fixed
              width="40">
          </el-table-column>
          <el-table-column
              prop="year"
              label="年"
              :show-overflow-tooltip="true"
              width="70">
          </el-table-column>
          <el-table-column
              prop="area"
              label="区域"
              :show-overflow-tooltip="true"
              width="60">
          </el-table-column>
          <el-table-column
              prop="agentCode"
              label="经销商编码"
              :show-overflow-tooltip="true"
              fixed
              width="100">
          </el-table-column>
          <el-table-column
              prop="agentName"
              label="经销商名称"
              :show-overflow-tooltip="true"
              fixed
              width="180">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.agentName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentType"
              label="经销商类型"
              :show-overflow-tooltip="true"
              width="100">
            <template slot-scope="scope">
              {{scope.row.agentType|dictname('fl_agent_type')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="salesRegionCode"
              label="渠道"
              :show-overflow-tooltip="true"
              width="100">
            <template slot-scope="scope">
              {{scope.row.salesRegionCode|dictname('fl_sales_region_qudao')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="belongIndustry"
              label="返利归属产业"
              :show-overflow-tooltip="true"
              width="120">
            <template slot-scope="scope">
              {{scope.row.belongIndustry|dictname('fl_belong_industry')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="rebateChainGroup"
              label="签约链群"
              :show-overflow-tooltip="true"
              width="90">
            <template slot-scope="scope">
              {{scope.row.rebateChainGroup|dictname('rebate_chain_group')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="qunianTongqi"
              label="去年同期(万元)"
              :show-overflow-tooltip="true"
              width="90">
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.qunianTongqi}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="jinnianGoal"
              label="今年目标(万元)"
              :show-overflow-tooltip="true"
              width="90">
            <template slot-scope="scope">
              <div style="text-align: right;">
                {{scope.row.jinnianGoal}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="1月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume1"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume1}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal1"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal1}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="2月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume2"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume2}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal2"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal2}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="3月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume3"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume3}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal3"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal3}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="4月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume4"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume4}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal4"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal4}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="5月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume5"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume5}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal5"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal5}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="6月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume6"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume6}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal6"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal6}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="7月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume7"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume7}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal7"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal7}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="8月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume8"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume8}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal8"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal8}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="9月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume9"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume9}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal9"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal9}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="10月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume10"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume10}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal10"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal10}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="11月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume11"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume11}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal11"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal11}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="12月" :show-overflow-tooltip="true">
            <el-table-column
                prop="salesVolume12"
                label="同期(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.salesVolume12}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal12"
                label="目标(万元)"
                :show-overflow-tooltip="true"
                width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.goal12}}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
              prop="planStatus"
              label="审批状态"
              width="120">
            <template slot-scope="scope">
              {{scope.row.planStatus|dictname('fl_goal_approve_status')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="statu"
              label="有效性"
              :show-overflow-tooltip="true"
              width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.statu == 2">有效</div>
              <div v-if="scope.row.statu == 5">已退出</div>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="200"
          >
            <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="genzongLiuch(scope.row)">跟踪审批
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="xiugaihistory(scope.row)">修改记录
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                       @click="uploaddownexcelflagbtn"
                       v-auth="'fllb_daoruXsjl'"
            >批量导入
            </el-button>
            <uploaddownexcel
                :visible.sync="uploaddownexcelflag"
                v-if="uploaddownexcelflag"
                clsname="goalImportExcel"
                :extparams="extparams"
                :startrow="3" @callback="uploadExcelFilecallbackXsjl" @geExtParams="get_extParams"/>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                       @click="uploaddownexcelflagbtnxiugai"
                       v-auth="'fl_xiugai_quyujl'"
            >目标修改
            </el-button>
            <uploaddownexcel
                :visible.sync="uploaddownexcelflagxiugai"
                v-if="uploaddownexcelflagxiugai"
                clsname="goalUploadExcel"
                :startrow="3" @callback="uploadExcelGoalXiugai"/>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportTargetExcel" v-auth="'fl_goal_pldc'">批量导出
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportTargetExcelPrint">导出打印
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    <el-dialog
        title="目标修改记录"
        :visible.sync="showhistoryxiugai"
        :fullscreen="false"
        width="85%"
        :modal="false">
      <div class="tanBox">
        <el-table
            :data="xiugaiData"
            style="width: 100%">
          <el-table-column
              prop="cdate"
              label="创建时间"
              :show-overflow-tooltip="true"
              width="120">
          </el-table-column>
          <el-table-column
              prop="planStatus"
              label="审核状态"
              :show-overflow-tooltip="true"
              width="120">
            <template slot-scope="scope">
              {{scope.row.planStatus|dictname('fl_goal_approve_status')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="salesRegionCode"
              label="渠道"
              :show-overflow-tooltip="true"
              width="90">
            <template slot-scope="scope">
              {{scope.row.salesRegionCode|dictname('sales_region')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="rebateChainGroup"
              label="链群"
              :show-overflow-tooltip="true"
              width="90">
            <template slot-scope="scope">
              {{scope.row.rebateChainGroup|dictname('rebate_chain_group')}}
            </template>
          </el-table-column>
          <el-table-column label="1月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal1}}</div>
            </template>
          </el-table-column>
          <el-table-column label="2月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal2}}</div>
            </template>
          </el-table-column>
          <el-table-column label="3月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal3}}</div>
            </template>
          </el-table-column>
          <el-table-column label="4月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal4}}</div>
            </template>
          </el-table-column>
          <el-table-column label="5月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal5}}</div>
            </template>
          </el-table-column>
          <el-table-column label="6月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal6}}</div>
            </template>
          </el-table-column>
          <el-table-column label="7月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal7}}</div>
            </template>
          </el-table-column>
          <el-table-column label="8月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal8}}</div>
            </template>
          </el-table-column>
          <el-table-column label="9月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal9}}</div>
            </template>
          </el-table-column>
          <el-table-column label="10月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal10}}</div>
            </template>
          </el-table-column>
          <el-table-column label="11月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal11}}</div>
            </template>
          </el-table-column>
          <el-table-column label="12月" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="text-align: right;">{{scope.row.goal12}}</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="xiugaiHistory"
              label="操作"
              :show-overflow-tooltip="true"
              width="90">
            <template slot-scope="scope">
              <el-button type="text" size="small" class="h-tableLink h-btn"
                         @click="genzongLiuch(scope.row)">跟踪审批
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
               @click="exportExcel">批量导出
        </el-button>-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
// import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import uploaddownexcel from "../../../components/uploaddown/uploadBanchExcel"
import updownfile from '../../../utils/updownfile';
export default {
  components: {
    uploaddownexcel,
  },
  data() {
    return {
      // 展开折叠筛选
      isScreen:false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),
      showhistory: false,
      instid: '',
      uploaddownexcelflag: false,
      uploaddownexcelflagxiugai:false,
      showhistoryxiugai:false,
      xiugaiData:[],
      //查询属性
      page: {
        pageSize: 20,
        pageNo: 1
      },
      q: {
        // ...this.page,
        id:'',
        agentNameLike: '',
        agentCodeLike: '',
        pageSize: 10,
        pageNo: 1,
        total: 0,
        year: 2025,
      },
      xiugaidaochu:null,
      //表单
      f:{
        id:null, //
        contractId:null, // 返利合同id
        agentName:null, // 经销商名称
        agentCode:null, // 经销商编码
        contractName:null, // 合同名称
        areaCode:null, // 区域编码
        area:null, // 区域
        rebateBase:null, // 返利基数
        rebateChainGroup:null, // 返利链群：样本网、药品网、其他、血液网、疫苗网、试剂网、液氮罐、合计
        sealsRegionCode: null, //渠道
        rebateSeries:null, // 返利系列：超低温产品、低温产品、恒温产品、生物安全产品、培养箱、其他产品、合计、U血液、U疫苗、U试剂、液氮罐
        delflag:null, // 是否已经执行定时，1表示已执行定时，0表示未执行定时
        organization:null, // 销售组织 乙方（海尔生物医疗股份有限公司，青岛海尔生物医疗科技有限公司）
        rebateType:null, // 返利类型 传统ct、试剂网、血液网、疫苗网等
        xiaoweiName:null, // 小微名称
        xioweiCode:null, // 小微编码
        qunianTongqi:null, // 去年同期
        jinnianGoal:null, // 今年目标
        salesVolume1:null, // 1月同期
        salesVolume2:null, // 2月同期
        salesVolume3:null, // 3月同期
        salesVolume4:null, // 4月同期
        salesVolume5:null, // 5月同期
        salesVolume6:null, // 6月同期
        salesVolume7:null, // 7月同期
        salesVolume8:null, // 8月同期
        salesVolume9:null, // 9月同期
        salesVolume10:null, // 10月同期
        salesVolume11:null, // 11月同期
        salesVolume12:null, // 12月同期
        goal1:null, // 1月目标
        goal2:null, // 2月目标
        goal3:null, // 3月目标
        goal4:null, // 4月目标
        goal5:null, // 5月目标
        goal6:null, // 6月目标
        goal7:null, // 7月目标
        goal8:null, // 8月目标
        goal9:null, // 9月目标
        goal10:null, // 10月目标
        goal11:null, // 11月目标
        goal12:null, // 12月目标
        year:null, // 年
        statu:null, // 合同状态
        contractStartTime:null, // 合同开始时间
        contractEndTime:null, // 合同结束时间
      },
      //table列表
      tableData: [],
      //操作标志
      optflag:'save',
      extparams:{}
    }
  },
  created() {
    this.query();
  },
  methods: {
    // 展开折叠
    collapseChange(){
      this.isScreen = !this.isScreen;
    },
    //目标批量导出
    exportTargetExcelPrint() {
      if(!this.q.year){
        this.$message.error("请选择年份");
      }else if(!this.q.agentNameLike){
        this.$message.error("请输入完整的经销商编码或名称");
      }else{
        ss.fanli.downloadExcelPrint(this.q).then(rd => {
          if(rd.f){
            updownfile.down("/api/swyl/v1/demo/flXsjlTarget/downloadExcelPrint", this.q, "post");
          }else{
            this.$msg.msgs(rd.msg);
          }
        });
      }
    },
    //目标批量导出
    exportTargetExcel() {
      updownfile.down("/api/swyl/v1/demo/flXsjlTarget/downloadExcel", this.q, "post");
    },
    //修改记录导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/demo/flNewTargetXiugai/downloadExcel", this.xiugaidaochu, "post");
    },
    xiugaihistory(v){
      ss.fanli.xiugaihistory(v).then(rd => {
        this.xiugaidaochu = v;
        this.showhistoryxiugai=true;
        this.xiugaiData = rd;
      });
    },
    query() {
      ss.fanli.pagefanliXsjl(this.q).then(rd=>{
        this.q.total = rd.total;
        this.tableData = rd.records;
      });

    },
    //导入
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploaddownexcelflagbtnxiugai() {
      this.uploaddownexcelflagxiugai = true;
    },
    uploadExcelFilecallbackXsjl() {
      this.query();
      this.$msg.msgs(rd.msg);
    },
    uploadExcelGoalXiugai() {
      this.query();
      this.$msg.msgs(rd.msg);
    },
    get_extParams(uuid){
      // console.log(uuid,"uuid");
      this.extparams.sessionId=uuid
    },
    //跟踪审批
    genzongLiuch(v) {
      console.log("instid", v);
      this.instid = v.instid;
      console.log(this.instid,"@@@@@@@@@@")
      this.showhistory = true;
    },
    //重置
    qingkong() {
      this.timeValue = null,
          // this.$refs["form"].resetFields();
          this.q = {
            pageSize: 10,
            pageNo: 1,
            total: 0,
            year:2025
          }
      this.query();
    },
    handleFilter() {
      this.query();
    },
  }
}
</script>
<style>
.sjwstyle .el-table thead.is-group th{
  background: #57aefe;
}
</style>
